import { render, staticRenderFns } from "./FooterTop.vue?vue&type=template&id=ef6545d0&scoped=true&"
import script from "./FooterTop.vue?vue&type=script&lang=js&"
export * from "./FooterTop.vue?vue&type=script&lang=js&"
import style0 from "./FooterTop.vue?vue&type=style&index=0&id=ef6545d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6545d0",
  null
  
)

export default component.exports